// import { useState } from 'react'; // , useContext
import { useLocation } from 'react-router-dom';
import type { IStage } from '../../../interfaces/IStage';
import '../../../css/adminstage.scss';
import '../../../css/stages/fiche.scss';
// import {
//   Divider, Grid, Paper, Typography, Box
// } from '@mui/material';

const FicheStage = () => {
  const location = useLocation();
  const stage = location.state?.stage as IStage;

  return (
    <div id="stage">
      <div id="title">
        <h1>Fiche du stage {stage.name}</h1>
      </div>

      <div id="fiche">
                
        <article className={`stage-fiche ${stage.designId === 3 ? "stage-design-3" : ""} ${stage.isCancelled ? 'stage-cancelled' : ''}`}>

          {/* TITRE */}
          <header className="stage-header" style={{ backgroundColor: stage.mainColor }}>
            <h2 className="stage-title"><span style={{ color: stage.mainColor }}>{stage.title.split("et")[0]}</span><br />ET {stage.title.split("et")[1]}</h2>
            {/* <h3 className="stage-subtitle">{stage.shortTitle}</h3> */}
          </header>

          {/* CORPS */}
          <div className="stage-body">

            {/* COLONNE GAUCHE */}
            <section className="stage-left">

              <div className={`stage-text ${stage.designId === 3 ? 'stage-text-3' : ''}`}>
                {stage.designId === 1 && <p className="stage-hook hook-left">{stage.hook}</p>}
                {stage.text}
              </div>
              

              <div className="stage-infos" style={{ backgroundColor: stage.mainColor }}>
                {stage.designId != 3 ? 
                <ul>
                  <li>Salle 2 de l'Institut Ste-Marie de Jambes (227, rue de l'Aurore)</li>
                  <li>{stage.target}</li>
                  <li>{stage.price}€ ({stage.priceReduction})</li>
                  <li>{stage.date}</li>
                </ul>
                :
                <ul>
                  <li>{stage.date}</li>
                  <li>{stage.price}€ ({stage.priceReduction})</li>
                  <li>Salle 2 de l'Institut Ste-Marie de Jambes (227, rue de l'Aurore)</li>
                  <li>{stage.target}</li>
                </ul>
}

                {/* <p></p> */}
                {/* <p><strong>Date :</strong> {stage.date}</p> */}
                {/* <p><strong>Public :</strong> {stage.target}</p> */}
                {/* <p><strong>Prix :</strong> {stage.price} €</p> */}
{/* 
                {stage.priceReduction && (
                  <p className="reduction">{stage.priceReduction}</p>
                )} */}
              </div>
            </section>

            {/* COLONNE DROITE */}
            <aside className="stage-right">
              {stage.designId != 1 && <p className="stage-hook hook-right">{stage.hook}</p>}
              <img src={stage.imageUrl} alt={stage.title} />
              <div className="inscription-box">
                {stage.designId === 3 ? <h4 style={{ color: "#0b5fa5"}}>Inscription</h4> : 
                <h4>Inscription</h4>}
                <p>creacirque@gmail.com</p>
                <p>0474 / 05 21 96</p>
              </div>
            </aside>

          </div>
        </article>
      </div>
    </div>
  );
}

export default FicheStage;
